import React from 'react';
import FullscreenItemPreload from './fullscreenItemPreload.js';
import {utils} from '../../utils/utils'

class FullscreenImage extends React.Component {
  constructor(props) {
    super(props);

    this.retryOnError = this.retryOnError.bind(this);
    this.onLoadImage = this.onLoadImage.bind(this);

    this.state = {
      loaded: false,
      failed: false,
      retries: 1
    }
  }

  retryOnError(e) {
  
    if (this.state.failed) {
      return false;
    } else if (this.state.retries > 3) {
      console.error('Error (including retries) loading item #' + this.props.item, e);
      this.setState({
        failed: true
      });
    } else {
      this.setState({
        retries: this.state.retries + 1
      });
    }
  }

  onLoadImage() {
    this.setState({
      loaded: true
    });
  }

  retryUrl() {
    const item = this.props.item;
    
    let url = item.resized_url['img'];
    
    const hasGetParam = url.indexOf('?') >= 0;
    
    if (!hasGetParam && !this.state.failed) {
      // url += hasGetParam ? '&' : '?';
      url += '?retry=' + this.state.retries;
    }

    return url;
    
  }
  render() {

    const item = this.props.item;

    const transform = 'translate3d(-50%, -50%, 0) scale(' + this.props.window.scale.min(item) + ')';
    const innerStyle = {
      'width': item.width + 'px',
      'height': item.height + 'px',
      'transform': transform,
      'WebkitTransform': transform,
      'MozTransform': transform,
      'msTransform': transform,
      'OTransform': transform
    };

    const smallScreenStyle = {
      'width': item.width + 'px',
      'height': item.height + 'px'
    };

    return (!this.props.isDummy) ? (
      <div>
        <FullscreenItemPreload window={this.props.window} loaded={this.state.loaded} item={this.props.item}/>
        <img
          data-hook="fullscreen-image"
          className={'fullscreen-item high-res ' + (this.state.loaded ? ' loaded ' : '') + (this.state.failed ? ' error ' : '')}
          src={this.retryUrl()}
          alt={item.alt}
          onError={this.retryOnError}
          onLoad={this.onLoadImage}
          key={'image'}
          style={utils.isSmallScreen() ? smallScreenStyle : innerStyle}
        />
      </div>
    ) : <div/>;
  }
}

export default FullscreenImage;



// WEBPACK FOOTER //
// ./components/fullscreen/fullscreenImage.js